/* unplugin-vue-components disabled */import script from "./GameFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./GameFrame.vue?vue&type=script&setup=true&lang=js"

import "./GameFrame.vue?vue&type=style&index=0&id=38f00098&lang=less"

const __exports__ = script;

export default __exports__